// Feature flags for the marketing / commercial layer.
//
// SUBSCRIPTIONS_ENABLED — master switch for paid tiering.
// When `false` the app behaves as a 100% free product for individuals:
//   • Paywall / UpgradeBanner render nothing
//   • SimGate treats every visitor and user as "full access"
//   • SaveSession never surfaces the 402 upgrade path
//   • Home / SectionPage skip Free/Pro chips and lock icons
//   • Dashboard hides the PlanCard
//   • /pricing redirects to `/`
// Flip back to `true` to re-enable subscription / Stripe flows — every
// paywall component, billing endpoint and Stripe integration still lives
// in the codebase untouched.
export const SUBSCRIPTIONS_ENABLED = false;
